"use strict";
var directiveModule = angular.module('documenteditor', ['templates', 'ui.bootstrap', 'lr.upload', 'ngFlash']);
directiveModule.directive('documenteditor', require('./directives/documenteditorDirective'));
directiveModule.directive('field', require('./directives/fieldDirective'));
directiveModule.directive('fieldEntry', require('./directives/fieldEntryDirective'));
directiveModule.controller('fieldImageCtrl', require('./controllers/fieldImageCtrl'));
directiveModule.controller('fieldEntryDefaultCtrl', require('./controllers/fieldEntryDefaultCtrl'));
directiveModule.controller('fieldEntryTextCtrl', require('./controllers/fieldEntryTextCtrl'));
directiveModule.controller('fieldEntryImageCtrl', require('./controllers/fieldEntryImageCtrl'));
directiveModule.controller('fieldEntryBildnrCtrl', require('./controllers/fieldEntryBildnrCtrl'));
directiveModule.controller('fieldEntryArchivnrCtrl', require('./controllers/fieldEntryArchivnrCtrl'));
directiveModule.controller('fieldEntryQuellenCtrl', require('./controllers/fieldEntryQuellenCtrl'));
directiveModule.controller('fieldEntryReadonlyCtrl', require('./controllers/fieldEntryReadonlyCtrl'));
module.exports = directiveModule;
